export default __webpack_public_path__ + "static/media/sy-dp5.ca9b9d21.png";